import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
export default class AuthenticateApi extends BaseApi {
    constructor() {
        super("users");
    }

    async login(username : string, password: string) : Promise<string | void> {
        const response = await this.api.post<{ id: string }>('Authenticate', { username, password });
        if (!response) return;

        if (response.isSuccess) {
            var authentication: IAuthentication = response.data as IAuthentication;
            sessionStorage.setItem('user', JSON.stringify(authentication));
            return authentication.id;
        } else {
            this.modelState = response.errorState;
        }
    }
}
